export default {"src":"/_next/static/media/cs2.d17111de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};